var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "versions",
    },
    [
      _c("div", { staticClass: "header" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t("chatbotv2.versionHistory")))]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              "justify-content": "end",
              "text-align": "center",
              "align-items": "center",
            },
          },
          [
            _vm.bar !== 0
              ? _c("a-icon", {
                  staticStyle: { "font-size": "21px" },
                  attrs: { type: "close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close-menu", 0)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "version" },
        _vm._l(_vm.versions(_vm.$route.params.id), function (version) {
          return _c(
            "div",
            {
              staticClass: "list-item",
              class: { active: version.version === _vm.selectedBoard },
              on: {
                click: function ($event) {
                  return _vm.changeVersion(version.version)
                },
              },
            },
            [
              _c("VersionCard", {
                attrs: {
                  "story-id": _vm.storyId,
                  "version-names": _vm.versionNames,
                  version: version,
                  "selected-board": _vm.selectedBoard,
                },
                on: {
                  changeVersion: _vm.changeVersion,
                  "selected-name": _vm.nameControl,
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }